<template>
	<div>
		<b-form-row>
			<b-col cols="4">
				<b-form-select v-model="serviceId" :options="[ { id: null, name: 'All' }, ...services ]" value-field="id" text-field="name"></b-form-select>
			</b-col>
			<b-col>
				<b-form-input placeholder="Search..." v-model="q" class="mb-2" />
			</b-col>
		</b-form-row>
		<b-table :items="giftTypes" :fields="[{ key: 'type', label: 'Donation type' }, 'value', 'media', 'strings', 'group', { key: 'actions', thClass: 'text-right', tdClass: 'text-right'}]" small striped :busy="loading>0">
			<template #cell(type)="data">
				<b-avatar size="3em" :src="data.item.images?.[0]?.url||data.item.image||data.item.image_url" badge-variant="none" class="mr-2">
					<template #badge><b-avatar size="1.5em" :src="data.item.service_icon?.url" v-if="data.item.service_icon?.url"/></template>
				</b-avatar>
				<div class="d-inline-block align-middle">
					{{data.item.name}} (<code>{{data.item.gift_type}}</code>)<br />
					<small class="text-muted">{{data.item.service_name}}</small>
				</div>
			</template>
			<template #cell(media)="data">
				<span v-if="data.item.sounds && data.item.sounds.length">
					{{data.item.sounds[0].filename||data.item.sounds[0].md5}} ({{bytesString(data.item.sounds[0].size)}}B)
					<span class="text-muted" v-if="data.item.sounds.length > 1">and {{data.item.sounds.length - 1}} more</span>
				</span>
				<br />
				<span v-if="data.item.images && data.item.images.length">
					{{data.item.images[0].filename||data.item.images[0].md5}} ({{bytesString(data.item.images[0].size)}}B)
					<span class="text-muted" v-if="data.item.images.length > 1">and {{data.item.images.length - 1}} more</span>
				</span>
			</template>
			<template #cell(value)="data">
				{{data.item.multiplier&&data.item.multiplier > 1?`${data.item.multiplier}x`:''}}{{data.item.value||''}} {{data.item.currency}}
			</template>
			<template #cell(strings)="data">
				{{data.item.string}}<br />
				{{data.item.string_multi}}
			</template>
			<template #cell(group)="data">
				<b-badge :variant="data.value?'success':'secondary'">{{data.value?'yes':'no'}}</b-badge>
			</template>
			<template #cell(actions)="data">
				<b-button-group size="sm">
					<b-button @click="$refs.modal.show(data.item.service_id, data.item.gift_type)" v-b-tooltip.hover.bottom title="Edit donation event"><b-icon icon="pencil-fill"></b-icon></b-button>
				</b-button-group>
			</template>
		</b-table>
		<pager :per-page="perPage" :skip="skip" :total="total" @change="setPage"></pager>
		<b-alert variant="danger" :show="!!error">{{error}}</b-alert>
		<dono-media-modal ref="modal" @saved="loadGiftTypes" />
	</div>
</template>

<script>
import debounce from 'debounce';
import Pager from '@/components/Pager.vue';
import DonoMediaModal from './Modal/DonoMedia.vue';
import util from '@/util.js';

export default {
	data() { return {
		loading: 0,
		modalLoading: 0,
		error: null,
		services: [],
		curUserGiftType: null,
		giftTypes: [],
		total: 0,
		skip: 0,
		perPage: 10,
		serviceId: null,
		q: '',
	}},
	components: {
		Pager,
		DonoMediaModal,
	},
	async mounted() {
		try {
			this.loading++;
			this.error = null;

			this.serviceId = parseInt(this.$route.query.serviceId)||null;
			this.q = this.$route.query.q||'';
			this.skip = parseInt(this.$route.query.skip||0)||0;
			this.perPage = parseInt(this.$route.query.perPage||10)||10;

			this.giftTypes = [];
			await Promise.all([
				this.loadGiftTypes(),
				this.loadServices(),
			]);

			this.$watch('$route', $route => {
				this.skip = parseInt($route.query.skip||0)||0;
				this.perPage = parseInt($route.query.perPage||10)||10;
				this.reloadGiftTypes();
			});
			this.$watch('q', debounce(q => this.$router.push({
				path: this.$route.path,
				query: {
					...this.$route.query,
					skip: undefined,
					q: q||undefined,
				},
			}), 300));
			this.$watch('serviceId', serviceId => this.$router.push({
				path: this.$route.path,
				query: {
					...this.$route.query,
					skip: undefined,
					serviceId: serviceId||undefined,
				},
			}));
		} catch(e) {
			console.error(e);
			this.error = e;
		} finally {
			this.loading--;
		}
	},
	methods: {
		setPage($event) {
			this.$router.push({
				path: this.$route.path,
				query: {
					...this.$route.query,
					skip: $event.skip || undefined,
					perPage: $event.perPage == 10 ? undefined : $event.perPage,
				},
			});
		},

		async loadServices() {
			const services = await this.$api.get('services');
			this.services = services.filter(s => s.capabilities.indexOf('chat') !== -1);
		},

		async loadGiftTypes() {
			const result = await this.$api.get('userGiftTypes', {
				q: this.$route.query.q||'',
				serviceId: parseInt(this.$route.query.serviceId)||'',
				skip: this.skip,
				limit: this.perPage,
			});
			this.giftTypes = result.results;
			this.total = result.total;
		},

		async reloadGiftTypes() {
			try {
				this.loading++;
				this.error = null;
				await this.loadGiftTypes();
			} catch(e) {
				console.error(e);
				this.error = e;
			} finally {
				this.loading--;
			}
		},
		bytesString(n, p) { return util.bytesString(n, p); },
	},
};
</script>
